import type {UpdateRepresentativeFormPayload} from "./update-representative.schema";

import {updateRepresentative} from "@project/sdk/sales";
import {UpdateRepresentativeBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../representative-keys";

import {updateRepresentativeMapper} from "./update-representative.mapper";

export function updateRepresentativeMutationOptions(representativeId: string) {
  return mutationOptions({
    mutationFn: (payload: UpdateRepresentativeFormPayload) =>
      updateRepresentative(
        representativeId,
        UpdateRepresentativeBody.parse(updateRepresentativeMapper.toSdk(payload)),
      ),
    mutationKey: representativeMutationKeys.updateRepresentative,
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)}),
        client.invalidateQueries({queryKey: representativeKeys.lists()}),
      ]);
    },
  });
}
